






















































































































	// @ts-ignore
    import _ from './CPageBlogDetailStandard.ts'; export default _;
